<mat-card>
  <mat-card-header>
    <mat-card-title>Detalle de Liquidación de Expensa</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching && item != null">

      <!-- DATOS DE EXPENSA -->
      <mat-expansion-panel [expanded]="true">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px; margin-right: 5px;">info</mat-icon> Datos de Expensa
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- CAMPOS EDITABLES Y NO EDITABLES DE LA EXPENSA -->
        <form [formGroup]="formGroup">

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>{{'Comunidad' | translate}}</b>: {{item.ExpensaCabecera?.ComunidadNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Período</b>: {{item.ExpensaCabecera?.ExpensaPeriodo}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label>Observaciones</mat-label>
                <textarea matInput formControlName="Observaciones" maxlength="300"></textarea>
                <mat-error *ngIf="!formGroup.controls['Observaciones'].valid && formGroup.controls['Observaciones'].touched">
                  {{ getErrorObservaciones() }}
                </mat-error>
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Observaciones</b>: {{item.ExpensaCabecera?.Observaciones}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label>Fecha Vencimiento*</mat-label>
                <input matInput [matDatepicker]="fechaVencimientoPicker" formControlName="FechaVencimiento" (click)="fechaVencimientoPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoPicker">
                </mat-datepicker-toggle>
                <mat-datepicker #fechaVencimientoPicker></mat-datepicker>
                <mat-error *ngIf="!formGroup.controls['FechaVencimiento'].valid && formGroup.controls['FechaVencimiento'].touched">
                  {{ getErrorFechaVencimiento() }}
                </mat-error>
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Vencimiento</b>: {{item.ExpensaCabecera?.FechaVencimiento | date:'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Importe</b>: {{item.ExpensaCabecera?.MonedaCodigo}} {{item.ExpensaCabecera?.Importe | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label>Segundo Vencimiento*</mat-label>
                <input matInput [matDatepicker]="fechaVencimiento2Picker" formControlName="FechaVencimiento2" (click)="fechaVencimiento2Picker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimiento2Picker">
                </mat-datepicker-toggle>
                <mat-datepicker #fechaVencimiento2Picker></mat-datepicker>
                <mat-error *ngIf="!formGroup.controls['FechaVencimiento2'].valid && formGroup.controls['FechaVencimiento2'].touched">
                  {{ getErrorFechaVencimiento2() }}
                </mat-error>
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Segundo Vencimiento</b>: {{item.ExpensaCabecera?.FechaVencimiento2 | date:'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Importe 2do. Venc.</b>: {{item.ExpensaCabecera?.MonedaCodigo}} {{item.ExpensaCabecera?.Importe2 | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">

              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label>Interés Vencimiento</mat-label>
                <input matInput formControlName="InteresVencimiento" type="number" (keyup.enter)="onGuardar()">
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Interés Vencimiento</b>: {{item.ExpensaCabecera?.InteresVencimiento | number: '1.2-2'}}%</mat-label>
                </div>
              </mat-expansion-panel>

            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">

              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label>Interés Mensual</mat-label>
                <input matInput formControlName="InteresMensual" type="number" (keyup.enter)="onGuardar()">
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Interés Mensual</b>: {{item.ExpensaCabecera?.InteresMensual | number: '1.2-2'}}%</mat-label>
                </div>
              </mat-expansion-panel>

            </div>

            <ng-container *ngIf="!esUsuarioFinal">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">

                <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit && !estaPublicada()">
                  <mat-label *ngIf="!isMetodosRedondeoExpensaSearching">Método Redondeo de Expensas</mat-label>
                  <mat-label *ngIf="isMetodosRedondeoExpensaSearching">Cargando...</mat-label>
                  <mat-select formControlName="MetodoRedondeoExpensa">
                    <mat-option *ngFor="let s of metodosRedondeoExpensaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!(canEdit && !estaPublicada())">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Método de Redondeo Expensa</b>: {{item.ExpensaCabecera?.MetodoRedondeoExpensaNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>

              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">

                <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                  <mat-label *ngIf="!isConceptosRecargoSearching">Concepto de Recargo</mat-label>
                  <mat-label *ngIf="isConceptosRecargoSearching">Cargando...</mat-label>
                  <mat-select formControlName="ConceptosRecargo" (selectionChange)="onConceptoRecargoChange()">
                    <mat-option *ngFor="let s of conceptosRecargoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Conceptos Recargo</b>: {{item.ExpensaCabecera?.ConceptosRecargoNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>

              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="mostrarSeleccionConceptosRecargo">

                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTiposGastosSearching">Gastos del Concepto de Recargo*</mat-label>
                  <mat-label *ngIf="isTiposGastosSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoGastosConceptosRecargo" multiple [compareWith]="compareTipoGastosConceptosRecargo">
                    <mat-option *ngFor="let s of tiposGastosList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Gastos del Concepto de Recargo</b>: {{tipoGastosConceptosRecargoString}}</mat-label>
                  </div>
                </mat-expansion-panel>

              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit && !estaPublicada()">
                  <mat-label>Fondo Operativo*</mat-label>
                  <input type="number" matInput formControlName="ImporteFondoOperativo" (wheel)="onWheel($event)">
                  <mat-error *ngIf="!formGroup.controls['ImporteFondoOperativo'].valid && formGroup.controls['ImporteFondoOperativo'].touched">
                    {{ getErrorImporteFondoOperativo() }}
                  </mat-error>
                </mat-form-field>
    
                  <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit || estaPublicada()">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Fondo Operativo</b>: {{item.ExpensaCabecera?.ImporteFondoOperativo | number: '1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true" [ngStyle]="{ 'background-color': estaPublicada() === true ? 'lightgreen' : 'indianred'}">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Estado</b>: {{item.ExpensaCabecera?.Estado}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="!item.ExpensaCabecera?.Activo">
                <mat-expansion-panel [expanded]="true" hideToggle="true" [ngStyle]="{ 'background-color': item.ExpensaCabecera?.Activo === true ? 'white' : 'indianred'}">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Activo</b>: {{item.ExpensaCabecera?.Activo ? 'Sí' : 'No'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

            </ng-container>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label>Nota Expensas</mat-label>
                <textarea matInput formControlName="NotaExpensas" rows="6"></textarea>
                <mat-error *ngIf="!formGroup.controls['NotaExpensas'].valid && formGroup.controls['NotaExpensas'].touched">
                  {{ getErrorNotaExpensas() }}
                </mat-error>
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nota Expensas</b>: {{item.ExpensaCabecera?.NotaExpensas}}</mat-label>
                </div>
              </mat-expansion-panel>

            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label>Nota en Pie de Expensas</mat-label>
                <textarea matInput formControlName="NotaExpensasPie" rows="6"></textarea>
                <mat-error *ngIf="!formGroup.controls['NotaExpensasPie'].valid && formGroup.controls['NotaExpensasPie'].touched">
                  {{ getErrorNotaExpensasPie() }}
                </mat-error>
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nota en Pie de Expensas</b>: {{item.ExpensaCabecera?.NotaExpensasPie}}</mat-label>
                </div>
              </mat-expansion-panel>

            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="item.ExpensaCabecera?.ExpensaAnteriorId > 0">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label style="text-align: center; width: 100%; font-weight: bold; text-decoration: underline;">
                    <a style="cursor: pointer;" (click)="viewExpensa(item.ExpensaCabecera?.ExpensaAnteriorId)">Ver Expensa Anterior</a>
                  </mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="item.ExpensaCabecera?.ExpensaSiguienteId > 0">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label style="text-align: center; width: 100%; font-weight: bold; text-decoration: underline;">
                    <a style="cursor: pointer;" (click)="viewExpensa(item.ExpensaCabecera?.ExpensaSiguienteId)">Ver Expensa Siguiente</a>
                  </mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </form>

        <!-- BOTON GUARDAR -->
        <ng-container *ngIf="canEdit">

          <div fxLayout="row-reverse stretch" fxLayout.xs="column">
            <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary" class="zb-button">
              {{isSaving ? 'Guardando...' : 'Guardar Datos de Expensa'}}
            </button>
          </div>

        </ng-container>

      </mat-expansion-panel>

      <br/>

      <!-- GASTOS DEL PERIODO -->
      <mat-expansion-panel [expanded]="true">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px; margin-right: 5px;">assignment</mat-icon> Gastos del Período
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- MENSAJE DE INFO CUANDO NO HAY GASTOS EN LA BAJA DE EXPENSA -->
        <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column" *ngIf="!item.ExpensaCabecera.Activo">
          <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="border-radius: 10px; background-color: lightblue; padding-bottom: 15px;">
            <mat-label style="font-weight: bold; text-align: center;">
              No se visualizan gastos asociados ya que los mismos fueron liberados y desasignados de la expensa cuando se dió de baja la misma.
            </mat-label>
          </div>
        </div>

        <!-- LISTADO DE GASTOS DEL PERIODO -->
        <ng-container *ngIf="item.GastosPeriodo != null && item.GastosPeriodo.length > 0">

          <div fxLayout="row-reverse stretch" class="zb-readonly" fxLayout.xs="column">
            <button mat-raised-button (click)="editGastosPeriodo()" [disabled]="isProcessing()" class="zb-button" color="primary" *ngIf="item.ExpensaCabecera.Activo && !estaPublicada()">
              Editar Gastos del Período
            </button>
            <button mat-raised-button (click)="pageGastosGrid()" [disabled]="isProcessing()" class="zb-button">
              {{gastosGridAllowPaging ? 'Ver Completo' : 'Ver Paginado'}}
            </button>
          </div>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">

            <mat-expansion-panel [expanded]="true" hideToggle="true">

              <mat-tab-group (selectedTabChange)="onGastosPeriodoTabChange($event)">

                <mat-tab label="{{'Comunidad' | translate}}">

                  <div fxLayout="row stretch" fxLayout.xs="column">

                    <!-- GRILLA DE GASTOS SIN AGRUPAR POR CATEGORIA -->
                    <ejs-grid #gastosComunidadPeriodoGrid [dataSource]='gastosComunidadPeriodoList' [allowPaging]="gastosGridAllowPaging" [allowSorting]="true" [toolbar]='toolbarOptions'
                      [selectionSettings]='gastosSelectionOptions' [pageSettings]='pageSettings' [allowResizing]='true' *ngIf="!gastosGridAllowGrouping"
                      [contextMenuItems]='gastosComunidadGridContextMenuItems' (contextMenuClick)='gastosComunidadGridContextMenuClick($event)' (contextMenuOpen)='gastosComunidadGridContextMenuOpen($event)'>
                      <e-columns>
                        <e-column field='Detalle' headerText='Detalle' width='120'></e-column>
                        <e-column field="TipoGasto" headerText='Tipo Gasto' width=100></e-column>
                        <e-column field="ServicioGasto" headerText='Rubro' width=100></e-column>
                        <e-column field='FechaGasto' headerText='Fecha' width='60'>
                          <ng-template #template let-data>
                            {{data.FechaGasto | date:'dd/MM/yyyy'}}
                          </ng-template>
                        </e-column>
                        <e-column field="Importe" headerText='Importe' width=90 textAlign='Right'>
                          <ng-template #template let-data>
                            {{data.Moneda}} {{data.Importe | number:'1.2-2'}}
                          </ng-template>
                        </e-column>
                        <e-column field="FechaVencimiento" headerText='Fecha Venc.' width=90>
                          <ng-template #template let-data>
                            {{data.FechaVencimiento | date:'dd/MM/yyyy'}}
                          </ng-template>
                        </e-column>
                        <e-column headerText='' width=60 *ngIf="canGastoView" textAlign='Center'>
                          <ng-template #template let-data>
                            <a style="cursor: pointer;" (click)="onViewGasto(data.Id)"><i class="fa fa-eye fa-1x"></i></a>
                          </ng-template>
                        </e-column>
                      </e-columns>
                    </ejs-grid>

                    <!-- GRILLA DE GASTOS AGRUPADOS POR CATEGORIA -->
                    <ejs-grid #gastosPeriodoGrid [dataSource]='item.GastosPeriodo' [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [allowPaging]="gastosGridAllowPaging"
                      [allowResizing]='true' [allowGrouping]='true' [groupSettings]='groupOptions' (actionFailure)="onGridActionFailure($event)" [pageSettings]='gastosGridPageSettings'
                      *ngIf="gastosGridAllowGrouping">
                      <e-columns>
                        <!-- <e-column field="ServicioGastoGrupoNombre" headerText='Categoria' width=20%></e-column> -->
                        <e-column field="ServicioGasto" headerText='Servicio' width=100></e-column>
                        <e-column field="Detalle" headerText='Detalle' width=150></e-column>
                        <e-column field="FechaGasto" headerText='Fecha Gasto' width=90>
                          <ng-template #template let-data>
                            {{data.FechaGasto | date:'dd/MM/yyyy'}}
                          </ng-template>
                        </e-column>
                        <!-- <e-column field="Moneda" headerText='Moneda' width=80></e-column> -->
                        <e-column field="Importe" headerText='Importe' width=90 textAlign='Right'>
                          <ng-template #template let-data>
                            {{data.Moneda}} {{data.Importe | number:'1.2-2'}}
                          </ng-template>
                        </e-column>
                        <e-column field="FechaVencimiento" headerText='Fecha Venc.' width=90>
                          <ng-template #template let-data>
                            {{data.FechaVencimiento | date:'dd/MM/yyyy'}}
                          </ng-template>
                        </e-column>
                        <e-column field="TipoGasto" headerText='Tipo Gasto' width=100></e-column>
                        <e-column field="ServicioGastoCategoriaNombre" headerText='Rubro' width=1></e-column>
                        <e-column headerText='' width=60 *ngIf="canGastoView" textAlign='Center'>
                          <ng-template #template let-data>
                            <a style="cursor: pointer;" (click)="onViewGasto(data.Id)"><i class="fa fa-eye fa-1x"></i></a>
                          </ng-template>
                        </e-column>
                      </e-columns>

                      <e-aggregates>
                        <e-aggregate>
                          <e-columns>
                            <e-column field="Importe" type="sum" textAlign='Right'>
                              <ng-template #groupFooterTemplate let-data>{{item.GastosPeriodo[0].Moneda}} {{data.sum | number:'1.2-2'}}</ng-template>
                            </e-column>
                          </e-columns>
                        </e-aggregate>
                      </e-aggregates>
                    </ejs-grid>

                  </div>

                  <div fxLayout="row-reverse stretch" fxLayout.xs="column" class="zb-readonly">

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item" fxLayoutAlign="end" style="font-weight: bold; margin-top: 5px;">
                      <a style="cursor: pointer; text-decoration: underline;" (click)="groupGastosGrid()">
                        {{gastosGridAllowGrouping ? 'Ver Sin Agrupar' : 'Ver Agrupado por Rubro'}}
                      </a>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="font-weight: bold; margin-top: 5px;">
                      Cantidad Total: {{cantidadGastosComunidadTotalSeleccionado}} - Monto Total: ${{gastosComunidadTotalSeleccionado | number:'1.2-2'}}
                    </div>

                  </div>

                </mat-tab>

                <mat-tab label="{{'UnidadFuncional' | translate}}">

                  <div fxLayout="row stretch" fxLayout.xs="column">

                    <ejs-grid #gastosUfsPeriodoGrid [dataSource]='gastosUfPeriodoList' [allowPaging]="gastosGridAllowPaging" [allowSorting]="true" [toolbar]='toolbarOptions'
                      [selectionSettings]='gastosSelectionOptions' [pageSettings]='pageSettings' [allowResizing]='true' [contextMenuItems]='gastosUfsGridContextMenuItems'
                       (contextMenuClick)='gastosUfsGridContextMenuClick($event)' (contextMenuOpen)='gastosUfsGridContextMenuOpen($event)'>
                      <e-columns>
                        <e-column field='UnidadFuncionalCodigo' headerText='Cód. UF' width='70'></e-column>
                        <e-column field='Detalle' headerText='Detalle' width='120'></e-column>
                        <e-column field="TipoGasto" headerText='Tipo Gasto' width=100></e-column>
                        <e-column field="ServicioGasto" headerText='Rubro' width=100></e-column>
                        <e-column field='FechaGasto' headerText='Fecha' width='90'>
                          <ng-template #template let-data>
                            {{data.FechaGasto | date:'dd/MM/yyyy'}}
                          </ng-template>
                        </e-column>
                        <e-column field="Importe" headerText='Importe' width=90 textAlign='Right'>
                          <ng-template #template let-data>
                            {{data.MonedaNombre}} {{data.Importe | number:'1.2-2'}}
                          </ng-template>
                        </e-column>
                        <e-column field="FechaVencimiento" headerText='Fecha Venc.' width=90>
                          <ng-template #template let-data>
                            {{data.FechaVencimiento | date:'dd/MM/yyyy'}}
                          </ng-template>
                        </e-column>
                        <e-column headerText='' width=60 *ngIf="canGastoView" textAlign='Center'>
                          <ng-template #template let-data>
                            <a style="cursor: pointer;" (click)="onViewGasto(data.Id)"><i class="fa fa-eye fa-1x"></i></a>
                          </ng-template>
                        </e-column>
                      </e-columns>
                    </ejs-grid>

                  </div>

                  <div fxLayout="row-reverse stretch" fxLayout.xs="column" class="zb-readonly">

                    <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="font-weight: bold; margin-top: 5px;">
                      Cantidad Total: {{cantidadGastosUfTotalSeleccionado}} - Monto Total: ${{gastosUfTotalSeleccionado | number:'1.2-2'}}
                    </div>

                  </div>

                </mat-tab>

              </mat-tab-group>

            </mat-expansion-panel>

          </div>

          <hr width="100%">

          <!-- TOTALIZADORES DE GASTOS -->
          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style" style="text-align: center; width: 100%;"><b>Cantidad Total</b>: {{cantidadGastosTotalSeleccionado}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style" style="text-align: center; width: 100%;"><b>Total en Gastos del Período</b>: ${{gastosTotalSeleccionado | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
          </div>

        </ng-container>

      </mat-expansion-panel>

      <br/>

      <!-- PRORRATEO EN UFS -->
      <mat-expansion-panel [expanded]="true">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px; margin-right: 5px;">settings</mat-icon> Prorrateo en UFs
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row-reverse stretch" class="zb-readonly" fxFlexAlign="end" fxLayout.xs="column" *ngIf="item != null && item.UfsLiquidacion != null && item.UfsLiquidacion.length > 0">
          <button mat-raised-button (click)="pageUfGrid()" [disabled]="isProcessing()" class="zb-button">
            {{ufGridAllowPaging ? 'Ver Completo' : 'Ver Paginado'}}
          </button>
        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" style="overflow: auto;" *ngIf="item != null && item.UfsLiquidacion != null && item.UfsLiquidacion.length > 0">

          <ejs-grid #ufGrid [dataSource]='item.UfsLiquidacion' [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [allowSorting]="false"
            [allowResizing]='true' (actionFailure)="onGridActionFailure($event)" [allowPaging]="ufGridAllowPaging" [pageSettings]='ufGridPageSettings'
            [contextMenuItems]='ufGridContextMenuItems' (contextMenuClick)='ufGridContextMenuClick($event)' (contextMenuOpen)='ufGridContextMenuOpen($event)'>
            <e-columns>
              <e-column headerText='' width="90" *ngIf="!esUsuarioFinal" ></e-column>

              <e-column field="UnidadFuncionalNumero" headerText='#' width="60"></e-column>
              <e-column field="UnidadFuncionalCodigo" headerText='Cód.' width="80"></e-column>
              <e-column field="Propietario" headerText='Persona' width="130"></e-column>

              <ng-container  *ngIf="tenantFeatureFlags?.HabilitarControlCaja">
                <e-column field="SaldoAnterior" headerText='Saldo Ant.' width="120"></e-column>
                <e-column field="PagosAnterior" headerText='Pagos Ant.' width="120"></e-column>
                <e-column field="SaldoGeneral" headerText='Saldo Actual' width="120"></e-column>
                <e-column field="Intereses" headerText='Interés' width="120"></e-column>
              </ng-container>

              <ng-container *ngFor="let gasto of item?.TiposGasto">
                <e-column field="Porcentaje-{{gasto?.TipoGastoId}}" headerText='% {{gasto?.TipoGasto}}' [visible]="gasto?.MostrarEnResumenExpensa" textAlign='Right' width="100"></e-column>
                <e-column field="Importe-{{gasto?.TipoGastoId}}" headerText='Gastos {{gasto?.TipoGasto}}' textAlign='Right' width="120"></e-column>
              </ng-container>

              <e-column field="Redondeo1" headerText='Redondeo' textAlign='Right' width="90"></e-column>
              <e-column *ngIf="item.ExpensaCabecera?.ImporteFondoOperativo > 0" field="FondoOperativo" headerText='Fondo Operativo' textAlign='Right' width="120"></e-column>
              <e-column field="TotalPrimerVencimiento" headerText='1er. Venc.' textAlign='Right' width="120"></e-column>
              <e-column field="TotalSegundoVencimiento" headerText='2do. Venc.' textAlign='Right' width="120"></e-column>
              <e-column field="PermitirGenerarInteres" headerText='Aplica Interés?' textAlign='Right' width="70" [visible]="!esUsuarioFinal"></e-column>
            </e-columns>

            <ng-template #rowTemplate let-data>
              <tr class="e-row">
                <td class="e-rowcell" align="left" *ngIf="!esUsuarioFinal">
                  <a style="cursor: pointer;" (click)="permitirGenerarIntereses(data)" *ngIf="data.PermitirGenerarInteres != null"
                    [title]="data.PermitirGenerarInteres != null && data.PermitirGenerarInteres == false ? 'Cobrar interés por mora' : 'No cobrar interés por mora'">
                    <mat-icon *ngIf="data.PermitirGenerarInteres" style="font-size: 16px;">event_available</mat-icon>
                    <mat-icon *ngIf="!data.PermitirGenerarInteres" style="font-size: 16px;">event_busy</mat-icon>
                  </a>
                  <a style="cursor: pointer; margin-left: 3px;" (click)="invitarPersona(data)" *ngIf="data.PuedeEnviarInvitacion" title="Enviar invitación al sistema">
                    <i class="fa fa-envelope fa-1x"></i>
                  </a>
                </td>

                <td class="e-rowcell" *ngIf="ufColumnVisibility['UnidadFuncionalNumero']">{{data.UnidadFuncionalNumero}}</td>
                <td class="e-rowcell" *ngIf="ufColumnVisibility['UnidadFuncionalCodigo']">{{data.UnidadFuncionalCodigo}}</td>
                <td class="e-rowcell" *ngIf="ufColumnVisibility['Propietario']">{{data.Propietario}}</td>

                <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlCaja">
                  <td class="e-rowcell" align="right" *ngIf="ufColumnVisibility['SaldoAnterior']">${{data.SaldoAnterior | number: '1.2-2'}}</td>
                  <td class="e-rowcell" align="right" *ngIf="ufColumnVisibility['PagosAnterior']">${{data.PagosAnterior | number: '1.2-2'}}</td>
                  <td class="e-rowcell" align="right" *ngIf="ufColumnVisibility['SaldoGeneral']">${{data.SaldoGeneral | number: '1.2-2'}}</td>
                  <td class="e-rowcell" align="right" *ngIf="ufColumnVisibility['Intereses']">${{data.Intereses | number: '1.2-2'}}</td>
                </ng-container>

                <ng-container *ngFor="let valor of data?.Valores">
                  <td class="e-rowcell" align="right" *ngIf="valor?.MostrarEnResumenExpensa && ufColumnVisibility['Porcentaje-'+ valor?.TipoGastoId]">{{valor.Porcentaje | number: '1.2-2'}}%</td>
                  <td class="e-rowcell" align="right" *ngIf="ufColumnVisibility['Importe-'+ valor?.TipoGastoId]" >${{valor.Importe | number: '1.2-2'}}</td>
                </ng-container>

                <td class="e-rowcell" align="right" *ngIf="ufColumnVisibility['Redondeo1']">${{data.Redondeo1 | number: formatRedondeo()}}</td>

                <td class="e-rowcell" align="right" *ngIf="ufColumnVisibility['FondoOperativo'] && item.ExpensaCabecera?.ImporteFondoOperativo > 0">${{data.FondoOperativo | number: '1.2-2'}}</td>
                <td class="e-rowcell" align="right" *ngIf="ufColumnVisibility['TotalPrimerVencimiento']">${{data.TotalPrimerVencimiento | number: '1.2-2'}}</td>
                <td class="e-rowcell" align="right" *ngIf="ufColumnVisibility['TotalSegundoVencimiento']">${{data.TotalSegundoVencimiento | number: '1.2-2'}}</td>

                <td class="e-rowcell" align="center" *ngIf="ufColumnVisibility['PermitirGenerarInteres'] && !esUsuarioFinal">{{data.PermitirGenerarInteres ? 'Sí' : 'No'}}</td>
              </tr>
            </ng-template>

            <e-aggregates>
              <e-aggregate>
                <e-columns>
                    <e-column field="SaldoAnterior" type="sum" align="right" textAlign='Right' *ngIf="tenantFeatureFlags?.HabilitarControlCaja">
                      <ng-template #footerTemplate let-data>
                        <p style="text-align: right; margin-bottom: 0px;">${{data.sum | number:'1.2-2'}}</p>
                      </ng-template>
                    </e-column>
                    <e-column field="PagosAnterior" type="sum" align="right" style="text-align: right;" textAlign='Right' *ngIf="tenantFeatureFlags?.HabilitarControlCaja">
                      <ng-template #footerTemplate let-data>
                        <p style="text-align: right; margin-bottom: 0px;">${{data.sum | number:'1.2-2'}}</p>
                      </ng-template>
                    </e-column>
                    <e-column field="SaldoGeneral" type="sum" align="right" textAlign='Right' *ngIf="tenantFeatureFlags?.HabilitarControlCaja">
                      <ng-template #footerTemplate let-data>
                        <p style="text-align: right; margin-bottom: 0px;">${{data.sum | number:'1.2-2'}}</p>
                      </ng-template>
                    </e-column>
                    <e-column field="Intereses" type="sum" align="right" textAlign='Right' *ngIf="tenantFeatureFlags?.HabilitarControlCaja">
                      <ng-template #footerTemplate let-data>
                        <p style="text-align: right; margin-bottom: 0px;">${{data.sum | number:'1.2-2'}}</p>
                      </ng-template>
                    </e-column>


                  <ng-container *ngFor="let gasto of item?.TiposGasto">
                    <e-column field="Porcentaje-{{gasto?.TipoGastoId}}" type="Custom" textAlign='Right' *ngIf="gasto?.MostrarEnResumenExpensa && ufColumnVisibility['Porcentaje-'+gasto?.TipoGastoId]">
                      <ng-template #footerTemplate let-data>
                        <p style="text-align: right; margin-bottom: 0px;">{{sumUfPorcentaje(gasto.TipoGastoId) | number:'1.2-2'}}%</p>
                      </ng-template>
                    </e-column>
                    <e-column field="Importe-{{gasto?.TipoGastoId}}" type="Custom" textAlign='Right'  *ngIf="ufColumnVisibility['Importe-'+gasto?.TipoGastoId]">
                      <ng-template #footerTemplate let-data>
                        <p style="text-align: right; margin-bottom: 0px;">${{sumUfImporte(gasto.TipoGastoId) | number:'1.2-2'}}</p>
                      </ng-template>
                    </e-column>
                  </ng-container>

                  <e-column field="Redondeo1" type="sum" textAlign='Right'>
                    <ng-template #footerTemplate let-data>
                      <p style="text-align: right; margin-bottom: 0px;">${{data.sum | number: formatRedondeo()}}</p>
                    </ng-template>
                  </e-column>
                  <e-column *ngIf="item.ExpensaCabecera?.ImporteFondoOperativo > 0" field="FondoOperativo" type="sum" textAlign='Right'>
                    <ng-template #footerTemplate let-data>
                      <p style="text-align: right; margin-bottom: 0px;">${{data.sum | number:'1.2-2'}}</p>
                    </ng-template>
                  </e-column>
                  <e-column field="TotalPrimerVencimiento" type="sum" textAlign='Right'>
                    <ng-template #footerTemplate let-data>
                      <p style="text-align: right; margin-bottom: 0px;">${{data.sum | number:'1.2-2'}}</p>
                    </ng-template>
                  </e-column>
                  <e-column field="TotalSegundoVencimiento" type="sum" textAlign='Right'>
                    <ng-template #footerTemplate let-data>
                      <p style="text-align: right; margin-bottom: 0px;">${{data.sum | number:'1.2-2'}}</p>
                    </ng-template>
                  </e-column>

                </e-columns>
              </e-aggregate>
            </e-aggregates>

          </ejs-grid>

        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="item.HayUfsSinCubrirTotal" style="margin-bottom: 15px;">
          <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="border-radius: 10px; background-color: lightblue; padding-bottom: 15px;">
            <mat-label style="font-weight: bold; text-align: center; padding-top: 15px;">
              <u>NOTA:</u> hay porcentajes de unidades funcionales que no suman el 100% de prorrateo para los gastos.
            </mat-label>
          </div>
        </div>

      </mat-expansion-panel>

      <!-- DATOS DEL CONSORCIO -->
      <ng-container *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">

        <br/>

        <mat-expansion-panel [expanded]="false">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">meeting_room</mat-icon> Datos de {{'Consorcio' | translate}}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nombre</b>: {{item.Consorcio.Nombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Razón Social</b>: {{item.Consorcio.RazonSocial}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Tipo Documento</b>: {{item.Consorcio.TipoDocumento}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>CUIT</b>: {{item.Consorcio.NroDocumento}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>País</b>: {{item.Consorcio.Pais}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Provincia</b>: {{item.Consorcio.Provincia}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Dirección</b>: {{item.Consorcio.Direccion}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Código Postal</b>: {{item.Consorcio.CodigoPostal}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Teléfono</b>: {{item.Consorcio.Telefono}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Email</b>: {{item.Consorcio.Email}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Tipo Responsable IVA</b>: {{item.Consorcio.TipoResponsableIva}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>

      </ng-container>

      <!-- Movimientos -->
      <ng-container *ngIf="item.ExpensaCabecera?.Id > 0 && canMovimientoView && !esUsuarioFinal && estaPublicada()">

        <br/>

        <mat-expansion-panel [expanded]="true" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">attach_money</mat-icon> Movimientos Asociados
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <mat-tab-group (selectedTabChange)="onMovimientosTabChange($event)">

            <mat-tab label="{{'MovimientoDeuda' | translate}}">

              <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-checkbox [(ngModel)]="verSoloMovimientosDeudaActivos" (change)="getMovimientoDeudas(item?.ExpensaCabecera?.Id)">Ver solo activos</mat-checkbox>
                </div>
                <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="end" class="flex-item">
                  <mat-label><b>Total Pendiente: ${{getTotalMovimientosPendientes() | number: '1.2-2'}} de ${{getTotalMovimientosDeudas() | number: '1.2-2'}}</b></mat-label>
                </div>
              </div>

              <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 0px;">

                <mat-label *ngIf="isMovimientosDeudasSearching">Buscando...</mat-label>
                <ejs-grid #deudasGrid [dataSource]='movimientoDeudaList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
                  [pageSettings]='pageSettings' [allowResizing]='true'[contextMenuItems]='deudasGridContextMenuItems' (contextMenuClick)='deudasGridContextMenuClick($event)' (contextMenuOpen)='deudasGridContextMenuOpen($event)'>
                  <e-columns>
                    <e-column field='FechaMovimiento' headerText='Fecha' width="90" type='date'>
                      <ng-template #template let-data>
                        {{data.FechaMovimiento | date:'dd/MM/yyyy'}}
                      </ng-template>
                    </e-column>
                    <!-- <e-column field='CuentaImputada' headerText='Referencia' width=80></e-column> -->
                    <e-column field='Detalle' headerText='Detalle' width="150"></e-column>
                    <e-column field='Estado' headerText='Estado' width="90">
                      <ng-template #template let-data>
                        <mat-label [ngStyle]="{ color: getEstadoBackgroundColor(data) }">{{data.Estado}}</mat-label>
                      </ng-template>
                    </e-column>
                    <e-column field='Monto' headerText='Monto' textAlign="right" width="90">
                      <ng-template #template let-data>
                        {{data.Moneda}} {{(data.Monto * -1) | number:'1.2-2'}}
                      </ng-template>
                    </e-column>
                    <e-column field='Saldo' headerText='Pendiente' textAlign="right" width="90">
                      <ng-template #template let-data>
                        {{data.Moneda}} {{(data.Saldo * -1) | number:'1.2-2'}}
                      </ng-template>
                    </e-column>
                    <e-column headerText='' width="40" textAlign='Center'>
                      <ng-template #template let-data>
                        <a style="cursor: pointer;" (click)="viewMovimiento(data)"><i class="fa fa-eye fa-1x"></i></a>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>

              </div>

            </mat-tab>

            <mat-tab label="{{'MovimientoPago' | translate}}">

              <div fxLayout="row-reverse stretch" fxLayout.xs="column" style="margin-top: 10px;">
                <!-- <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-checkbox [(ngModel)]="verSoloMovimientosPagoActivos">Ver solo activos</mat-checkbox>
                </div> -->
                <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="end" class="flex-item">
                  <mat-label><b>Total Abonado: ${{getTotalMovimientosPagos() | number: '1.2-2'}} de ${{getTotalMovimientosDeudas() | number: '1.2-2'}}</b></mat-label>
                </div>
              </div>

              <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 0px;">

                <mat-label *ngIf="isMovimientosPagoSearching">Buscando...</mat-label>
                <ejs-grid #pagosGrid [dataSource]='movimientoPagoList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
                  [pageSettings]='pageSettings' [allowResizing]='true' [contextMenuItems]='pagosGridContextMenuItems' (contextMenuClick)='pagosGridContextMenuClick($event)' (contextMenuOpen)='pagosGridContextMenuOpen($event)'>
                  <e-columns>
                    <e-column field='FechaMovimiento' headerText='Fecha' width=90 type='date'>
                      <ng-template #template let-data>
                        {{data.FechaMovimiento | date:'dd/MM/yyyy HH:mm:ss'}}
                      </ng-template>
                    </e-column>
                    <!-- <e-column field='CuentaImputada' headerText='Referencia' width=80></e-column> -->
                    <e-column field='TipoMovimientoNombre' headerText='Tipo' width=80></e-column>
                    <e-column field='Detalle' headerText='Detalle' width=120></e-column>
                    <e-column field='MedioPagoNombre' headerText='Medio Pago' width=70></e-column>
                    <e-column field='Monto' headerText='Monto' textAlign="right" width=70>
                      <ng-template #template let-data>
                        {{data.Moneda}} {{data.Monto | number:'1.2-2'}}
                      </ng-template>
                    </e-column>
                    <e-column headerText='Acciones' width=45 textAlign='Center'>
                      <ng-template #template let-data>
                        <a style="cursor: pointer; margin-right: 5px" (click)="viewMovimiento(data)">
                          <i class="fa fa-eye fa-1x"></i>
                        </a>
                        <a style="cursor: pointer;" (click)="onMovimientoReject(data)" *ngIf="data.PuedeRechazar" title="Cancelar movimiento">
                          <i class="fa fa-times fa-1x"></i>
                        </a>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>

              </div>

            </mat-tab>

          </mat-tab-group>

        </mat-expansion-panel>

      </ng-container>

    </div>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">
    <div fxLayout="row stretch" fxLayout.xs="column">
      <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">Cerrar</button>

      <ng-container *ngIf="!isSearching && item != null">
        <button mat-raised-button (click)="onDocumentPrint()" [disabled]="isProcessing()" *ngIf="item.ExpensaCabecera?.Activo" class="zb-button">
          {{isExporting ? 'Procesando...' : 'Ver/Imprimir Detalle'}}
        </button>
        <button mat-raised-button (click)="onDocumentSend()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary" class="zb-button">
          {{isSending ? 'Enviando...' : 'Enviar Detalle'}}
        </button>
        <button mat-raised-button (click)="onEstadoChange()" *ngIf="canEdit" [disabled]="isProcessing()" class="zb-button" color="warn">
          {{isEstadoChanging ? 'Procesando...' : (estaPublicada() ? 'Pasar a Borrador' : 'Publicar')}}
        </button>
        <button mat-raised-button (click)="onDelete()" *ngIf="canDelete" [disabled]="isProcessing()" color="accent" class="zb-button">
          {{isDeleting ? 'Procesando...' : 'Dar de Baja'}}
        </button>
      </ng-container>
    </div>
  </mat-card-actions>

</mat-card>
